import { Box, FormControl, TextField } from '@mui/material';
export interface IDetailFieldProps {
  name: string;
  value?: string | number | Date | undefined;
}

const DetailField: React.FC<React.PropsWithChildren<IDetailFieldProps>> = ({
  name,
  value,
}) => {
  return (
    <Box flex={1}>
      <FormControl fullWidth>
        <TextField
          focused={false}
          fullWidth
          autoFocus={false}
          value={value}
          variant='standard'
          size='small'
          name='detail-field'
          label={name}
          InputProps={{
            readOnly: true,
          }}
          inputProps={{
            readOnly: true,
            style: {
              textAlign: 'center',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          }}
          InputLabelProps={{
            color: 'info',
            variant: 'filled',
            disableAnimation: false,
          }}
        />
      </FormControl>
    </Box>
  );
};

export default DetailField;
